import { Card, CopyField } from '@/shared/components';
import { useTranslation } from 'react-i18next';

type Props = {
  walletId: string | null;
  label?: string;
};

const WalletCard = ({ walletId, label }: Props) => {
  const { t } = useTranslation();

  if (!walletId) {
    return null;
  }

  return (
    <Card className="p-[0.8rem] rounded-[1.6rem] w-full shadow-none gap-1">
      <CopyField
        value={walletId}
        label={label || t('personalAccount.userProfile.walletCardLabelText')}
        variant="list-item"
      />
    </Card>
  );
};

export { WalletCard };
